import React, { useEffect, useState } from "react";
import { Header } from "../header/Header";
import { Sidebar } from "../sidebar/Sidebar";
import { API_URL } from "../../utils/Url";
import { useNavigate } from "react-router-dom";

export const UserPlan = () => {
  const [userPlans, setUserPlans] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const usersPerPage = 50;

  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();

  const getAllUsersPlans = async (page = 1) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_URL}/api/subscription/getAllSubscriptionsUser?page=${page}&limit=${usersPerPage}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await response.json();

      if (response.ok) {
        setUserPlans(data.data || []);
        setTotalPages(data.pagination?.pages || 1);
      } else {
        console.error("Failed to fetch subscription profiles:", data.message);
      }
    } catch (error) {
      console.error("Error fetching user data models:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllUsersPlans(currentPage);
  }, [currentPage]);

  const goToDetails = (id) => {
    if (id) navigate(`/userPlans-details/${id}`);
  };

  return (
    <>
      <Header />
      <Sidebar />

      <div
        className="main-content mt-5 px-3 px-md-4 py-4"
        style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}
      >
        {/* PREMIUM SUB-MODULE HEADER BOARD */}
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-3 mb-4 p-3 bg-white border rounded-4 shadow-sm">
          <div>
            <h2 className="fw-bold text-gray-800 mb-0 fs-3">
              Premium User Registry
            </h2>
            <p className="text-muted small mb-0">
              Monitor active premium accounts, verified user credentials, and
              enrollment data.
            </p>
          </div>
          <div className="bg-primary-subtle px-3 py-2 rounded-3 border border-primary-subtle">
            <span className="text-primary small fw-semibold me-1">
              Active Batches:
            </span>
            <span className="fw-bold text-primary font-monospace">
              Page {currentPage} of {totalPages}
            </span>
          </div>
        </div>

        {/* CORE SYSTEM DATA PRESENTATION HOUSING */}
        <div className="card border-0 rounded-4 shadow-sm overflow-hidden">
          <div className="card-body p-0">
            {loading ? (
              <div className="d-flex flex-column align-items-center justify-content-center py-5">
                <div
                  className="spinner-border text-primary mb-3"
                  role="status"
                ></div>
                <span className="text-muted small fw-medium">
                  Streaming subscriber profiles from data grid...
                </span>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0 custom-admin-table">
                  <thead className="bg-light border-bottom">
                    <tr>
                      <th
                        className="text-muted text-uppercase fs-7 fw-bold px-4 py-3"
                        style={{ width: "65px" }}
                      >
                        #
                      </th>
                      <th
                        className="text-muted text-uppercase fs-7 fw-bold py-3"
                        style={{ width: "80px" }}
                      >
                        Avatar
                      </th>
                      <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                        Subscriber Identity
                      </th>
                      <th
                        className="text-muted text-uppercase fs-7 fw-bold py-3"
                        style={{ width: "110px" }}
                      >
                        Bar Credential
                      </th>
                      <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                        Communication Info
                      </th>
                      <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                        Account State
                      </th>
                      <th className="text-muted text-uppercase fs-7 fw-bold px-4 py-3">
                        Enrollment Date
                      </th>
                    </tr>
                  </thead>

                  <tbody className="border-0">
                    {userPlans.length > 0 ? (
                      userPlans.map((u, index) => {
                        const targetUser = u?.userId;
                        const hasImages =
                          targetUser?.userImages &&
                          targetUser.userImages.length > 0;
                        const avatarUrl = hasImages
                          ? `${API_URL}${targetUser.userImages[targetUser.userImages.length - 1].picUrl}`
                          : "https://cdn-icons-png.flaticon.com/512/3177/3177440.png";

                        return (
                          <tr
                            key={u._id}
                            className="align-middle transition-all"
                          >
                            {/* Counter Calculation */}
                            <td className="px-4 fw-semibold text-muted">
                              {(currentPage - 1) * usersPerPage + index + 1}
                            </td>

                            {/* Circular Image Container Layer */}
                            <td>
                              <div
                                className="position-relative rounded-circle overflow-hidden border bg-light shadow-xs"
                                style={{ width: "44px", height: "44px" }}
                              >
                                <img
                                  src={avatarUrl}
                                  alt=""
                                  className="w-100 h-100 object-cover"
                                  onError={(e) => {
                                    e.target.src =
                                      "https://cdn-icons-png.flaticon.com/512/3177/3177440.png";
                                  }}
                                />
                              </div>
                            </td>

                            {/* User Name Interaction Anchor */}
                            <td>
                              <span
                                className="fw-bold text-primary text-decoration-none d-block fs-6"
                                style={{ cursor: "pointer" }}
                                onClick={() => goToDetails(targetUser?._id)}
                              >
                                {targetUser?.name ||
                                  "Unformatted Identity Schema"}
                              </span>
                            </td>

                            {/* Interactive Document Thumbnail Box */}
                            <td>
                              {targetUser?.enrollIdImg ? (
                                <div
                                  className="position-relative border rounded shadow-xs overflow-hidden bg-light"
                                  style={{
                                    width: "65px",
                                    height: "42px",
                                    cursor: "zoom-in",
                                  }}
                                  onClick={() =>
                                    window.open(
                                      targetUser.enrollIdImg,
                                      "_blank",
                                    )
                                  }
                                  title="Click to open ID document partition"
                                >
                                  <img
                                    src={targetUser.enrollIdImg}
                                    alt="Bar Document"
                                    className="w-100 h-100 object-cover"
                                  />
                                </div>
                              ) : (
                                <span className="text-muted small italic">
                                  Missing Doc
                                </span>
                              )}
                            </td>

                            {/* Split Contact System Grid channels */}
                            <td>
                              <div className="text-dark fw-medium fs-7">
                                <i className="bi bi-envelope text-muted me-1.5"></i>
                                {targetUser?.email || "—"}
                              </div>
                              {targetUser?.mobile && (
                                <div
                                  className="text-muted small mt-0.5"
                                  style={{ fontSize: "12px" }}
                                >
                                  <i className="bi bi-telephone text-muted me-1.5"></i>
                                  {targetUser.mobile}
                                </div>
                              )}
                            </td>

                            {/* Status State Badge */}
                            <td>
                              <span
                                className={`badge px-3 py-1.5 rounded-pill fw-bold border text-capitalize fs-7 ${
                                  u.subscriptionStatus === "active"
                                    ? "bg-success-subtle text-success border-success-subtle"
                                    : "bg-secondary-subtle text-secondary border-secondary-subtle"
                                }`}
                              >
                                <span
                                  className="d-inline-block rounded-circle me-1.5"
                                  style={{
                                    width: "6px",
                                    height: "6px",
                                    backgroundColor:
                                      u.subscriptionStatus === "active"
                                        ? "#137333"
                                        : "#5f6368",
                                  }}
                                ></span>
                                {u.subscriptionStatus || "inactive"}
                              </span>
                            </td>

                            {/* Creation Timestamp Output */}
                            <td className="px-4 text-muted fs-7">
                              {u.createdAt
                                ? new Date(u.createdAt).toLocaleDateString(
                                    "en-IN",
                                    {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    },
                                  )
                                : "—"}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-5">
                          <div className="text-muted d-flex flex-column align-items-center justify-content-center gap-2">
                            <i className="bi bi-people fs-1 text-gray-300"></i>
                            <p className="mb-0 fw-semibold text-dark fs-5">
                              No Members Discovered
                            </p>
                            <p className="mb-0 text-muted small">
                              No structural profiles currently hold assigned
                              tier subscriptions.
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* SYNCED PAGINATION COMPONENT BAR */}
            {!loading && totalPages > 1 && (
              <div className="d-flex justify-content-between align-items-center p-4 border-top bg-light-subtle">
                <div className="text-muted small">
                  Displaying pagination block{" "}
                  <span className="fw-semibold text-dark">{currentPage}</span>{" "}
                  of <span className="fw-semibold text-dark">{totalPages}</span>{" "}
                  data buffers.
                </div>
                <nav>
                  <ul className="pagination pagination-sm mb-0 gap-1">
                    <li
                      className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link rounded-2 border px-3 fw-semibold"
                        onClick={() => setCurrentPage(1)}
                        disabled={currentPage === 1}
                      >
                        First
                      </button>
                    </li>
                    <li
                      className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link rounded-2 border px-3 fw-semibold"
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                      >
                        Prev
                      </button>
                    </li>

                    <li className="page-item active">
                      <span className="page-link rounded-2 border px-3 fw-bold">
                        {currentPage}
                      </span>
                    </li>

                    <li
                      className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link rounded-2 border px-3 fw-semibold"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages),
                          )
                        }
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </li>
                    <li
                      className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link rounded-2 border px-3 fw-semibold"
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                      >
                        Last
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
